import React, { useState, useEffect } from "react";
import apiClient from "../api/apiClient";

const Tracker = () => {
  const [history, setHistory] = useState([]);
  const [prediction, setPrediction] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [today] = useState(new Date().toISOString().split("T")[0]);

  useEffect(() => {
    document.body.className = "gynecare-page";
    fetchData();
    return () => {
      document.body.className = "";
    };
  }, []);

  const fetchData = async () => {
    try {
      const [h, p] = await Promise.all([
        apiClient.get("/period/history"),
        apiClient.get("/period/next"),
      ]);
      setHistory(h.data);
      setPrediction(p.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleLog = async (e) => {
    e.preventDefault();
    try {
      await apiClient.post("/period", { startDate });
      alert("Cycle Logged!");
      setStartDate("");
      fetchData();
    } catch (err) {
      alert("Error logging date");
    }
  };

  return (
    <main>
      {/* Header Section */}
      <section className="page-title-section">
        <div className="container">
          <h1>
            <i className="fas fa-calendar-alt"></i> Period Tracker
          </h1>
          <p>Smart cycle insights & women's wellness resources.</p>
        </div>
      </section>

      <div className="container" style={{ padding: "3rem 2rem" }}>
        {/* Tracker Dashboard Grid */}
        <div className="dashboard-grid">
          <div className="card">
            <div className="card-icon">
              <i className="fas fa-plus"></i>
            </div>
            <h3>Log New Entry</h3>
            <form onSubmit={handleLog} style={{ marginTop: "1rem" }}>
              <input
                type="date"
                className="form-control"
                min={today}
                onChange={(e) => setStartDate(e.target.value)}
                value={startDate}
                required
                style={{
                  width: "100%",
                  padding: "0.8rem",
                  borderRadius: "8px",
                  border: "1px solid #ddd",
                }}
              />
              <button
                type="submit"
                className="btn btn-primary"
                style={{ width: "100%", marginTop: "1rem" }}
              >
                Save Date
              </button>
            </form>
          </div>

          <div className="card card-highlight">
            <div className="card-icon">
              <i className="fas fa-magic"></i>
            </div>
            <h3>Next Prediction</h3>
            <p style={{ fontSize: "1.4rem", fontWeight: "800" }}>
              {prediction
                ? new Date(prediction.predictedNextPeriod).toDateString()
                : "Pending..."}
            </p>
          </div>

          <div className="card">
            <div className="card-icon">
              <i className="fas fa-history"></i>
            </div>
            <h3>History</h3>
            <div style={{ maxHeight: "150px", overflowY: "auto" }}>
              {history.map((item, index) => (
                <div
                  key={index}
                  style={{ padding: "8px 0", borderBottom: "1px solid #eee" }}
                >
                  <strong>
                    {new Date(item.startDate).toLocaleDateString()}
                  </strong>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 🌸 NEW SECTION: GyneCare Health Articles */}
        <section style={{ marginTop: "5rem" }}>
          <h2
            style={{
              textAlign: "center",
              marginBottom: "2.5rem",
              color: "var(--gyne-primary)",
            }}
          >
            <i className="fas fa-heartbeat"></i> Women's Health Essentials
          </h2>

          <div className="specialty-cards">
            {/* Article 1: PCOD/PCOS */}
            <article className="card">
              <div className="card-icon" style={{ color: "#e91e63" }}>
                <i className="fas fa-flower"></i>
              </div>
              <h3>Understanding PCOD</h3>
              <p>
                Learn about hormonal balance, symptoms, and how lifestyle
                changes can help manage PCOD effectively.
              </p>
              <button
                className="btn btn-outline btn-small"
                style={{ marginTop: "auto" }}
              >
                Read More
              </button>
            </article>

            {/* Article 2: Nutrition */}
            <article className="card">
              <div className="card-icon" style={{ color: "#4caf50" }}>
                <i className="fas fa-apple-alt"></i>
              </div>
              <h3>Period Nutrition</h3>
              <p>
                Best foods to eat during your cycle to reduce cramps and boost
                your energy levels naturally.
              </p>
              <button
                className="btn btn-outline btn-small"
                style={{ marginTop: "auto" }}
              >
                Read More
              </button>
            </article>

            {/* Article 3: Mental Health */}
            <article className="card">
              <div className="card-icon" style={{ color: "#9c27b0" }}>
                <i className="fas fa-brain"></i>
              </div>
              <h3>PMS & Mental Health</h3>
              <p>
                Expert tips on managing mood swings and anxiety during your
                premenstrual phase.
              </p>
              <button
                className="btn btn-outline btn-small"
                style={{ marginTop: "auto" }}
              >
                Read More
              </button>
            </article>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Tracker;
